import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners} from '@angular/core'
import {provideRouter, withComponentInputBinding, withHashLocation} from '@angular/router'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {ADMIN_ROLE, HOME_PATH} from './0-application/shared'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import localeFr from '@angular/common/locales/fr'
import localeSv from '@angular/common/locales/sv'
import {registerLocaleData} from '@angular/common'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatPaginatorIntl} from '@angular/material/paginator'

registerLocaleData(localeFr)
registerLocaleData(localeSv)

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE]
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till lönsamhetskalkyl, för att använda tjänsten måste du identifiera dig',
        buttonText: 'Logga in med BankID',
        route: ['/', HOME_PATH]
      }
    },
    {
      provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline', floatLabel: 'always', subscriptSizing: 'dynamic'}
    },
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv},

    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes,
      withComponentInputBinding(),
      withHashLocation()
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}
